export const FILTER_DATE_RANGE = {
    today: { value: 1, display: 'Yesterday', summary: 'daily' },
    week: { value: 7, display: 'Last 7 days', summary: 'weekly' },
    thirtyDays: { value: 30, display: 'Last 30 days', summary: 'monthly' },
    // sixtyDays: "Last 60 days",
    // ninetyDays: "Last 90 days"
};

export const SORT_OPTIONS = {
    session_desc: { display: 'Sort by sessions ↓', field: 'sessions', ascending: false },
    session_asc: { display: 'Sort by sessions ↑', field: 'sessions', ascending: true },
    user_desc: { display: 'Sort by users ↓', field: 'activeDevices', ascending: false },
    user_asc: { display: 'Sort by users ↑', field: 'activeDevices', ascending: true },
    crash_desc: { display: 'Sort by crashes ↓', field: 'crashes', ascending: false },
    crash_asc: { display: 'Sort by crashes ↑', field: 'crashes', ascending: true },
    crashfree_desc: { display: 'Sort by crash free % ↓', field: 'crashFreeSessions', ascending: false },
    crashfree_asc: { display: 'Sort by crash free % ↑', field: 'crashFreeSessions', ascending: true },
    unique_desc: { display: 'Sort by unique crashes ↓', field: 'uniqueCrashes', ascending: false },
    unique_asc: { display: 'Sort by unique crashes ↑', field: 'uniqueCrashes', ascending: true },
};

export const CHART_TYPES = {
    crashes: 'Crashes',
    activity: 'Activity',
};

export const colors = {
    sessions: '#113ea8',
    users: '#29a8d6',
    crashFree: '#ff8f17',
    crashes: '#d14343',
};

export const APP_CENTER_OWNER_NAME = 'mobileappsdelivery-6rkm';
export const APP_CENTER_READ_KEY = '3e05e70964adb0a4b540cd699aa0e264ba482f30';
export const APPS_MONITORING_SCOPE = 'api://54e53db6-d02f-4575-95a5-bdd963da8593/analytics';
export const GRAPH_SCOPE = 'Directory.Read.All';
export const CORESERVICES_ACC_SCOPE = 'https://EMCloudAD.onmicrosoft.com/5c7e6896-4a15-47f3-88ba-86939fd5ef35/config:update';
export const CORESERVICES_DEV_SCOPE = 'https://EMCloudAD.onmicrosoft.com/c95d6efe-c7dd-441f-8fbe-1af398195989/config:update';
export const CORESERVICES_PRD_SCOPE = 'https://EMCloudAD.onmicrosoft.com/a4c25b63-664a-45ef-b58c-fc63c326200e/config:update';
export const XOM_CONTACTS_SCOPE = 'api://a3950f2f-ce2e-4b93-9a96-0ad11719d2c4/users.read';
export const LINK_APP_CENTER_MIGRATION =
    'https://wiki.ds.xom.cloud/books/ios-development-best-practices/page/transition-plan-for-crashlytics-and-analytics';

// export const GRAPH_BASE_URL = 'https://graph.microsoft.com/v1.0';
export const GRAPH_BASE_URL = 'https://xom-contacts-api-prd.apps.xom.cloud/api';

export const configStatuses = {
    0: ['negative', 'Inactive'],
    1: ['positive', 'Active'],
    2: ['caution', 'Archived'],
};

export default {
    FILTER_DATE_RANGE,
    APP_CENTER_OWNER_NAME,
    APP_CENTER_READ_KEY,
    LINK_APP_CENTER_MIGRATION,
};
